import { Badge, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";

export default function Rates() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-semibold tracking-tight mb-6">Rates & Packages</h1>
      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>King Bed Tent</CardTitle>
            <Badge variant="secondary">THB 2,500 / night</Badge>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            Perfect for couples. Optional breakfast add‑on available.
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Double‑Queen Tent</CardTitle>
            <Badge variant="secondary">THB 3,500 / night</Badge>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            Ideal for families or friends. Optional breakfast add‑on available.
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
